module.exports = __webpack_public_path__ + "static/img/logo2.b199e6b5.svg";